<h2 mat-dialog-title>Activer une licence Medispring Light</h2>

<form [formGroup]="form">
  <div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Numéro INAMI</mat-label>
      <input matInput formControlName="encodedNihii" />
      @if (hasNihiiError) {
        <mat-error>
          @if (encodedNihiiControl.hasError('required')) {
            L'INAMI est obligatoire.
          } @else if (encodedNihiiControl.hasError('nihiiLength')) {
            L'INAMI normalisé doit contenir au moins 8 chiffres.
          } @else if (encodedNihiiControl.hasError('nihiiCheckDigit')) {
            L'INAMI est invalide.
          }
        </mat-error>
      }
    </mat-form-field>

    <p class="normalized-preview">
      Valeur enregistrée : <strong>{{ normalizedNihii || 'Aucun' }}</strong>
    </p>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="closeDialog()">Annuler</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canSubmit" (click)="addLicense()">Activer MS Light</button>
  </div>
</form>
